import { render } from "./About.vue?vue&type=template&id=0cebcd22"
const script = {}
script.render = render

export default script